"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var viewport_1 = require("../viewport");
var utils_1 = require("../utils");
var planimetry_1 = require("../planimetry");
var shapes_1 = require("../shapes");
var shapes_2 = require("./shapes");
var ModifyAbleRectShape_1 = require("./shapes/ModifyAbleRectShape");
var R_1 = require("../R");
/**
 * 模式
 */
var Mode;
(function (Mode) {
    /**
     * 移动
     */
    Mode[Mode["Move"] = 0] = "Move";
    /**
     * 缩放
     */
    Mode[Mode["Zoom"] = 1] = "Zoom";
    /**
     * 选择图元
     */
    Mode[Mode["SelectShape"] = 2] = "SelectShape";
    /**
     * 移动图元
     */
    Mode[Mode["MoveShape"] = 3] = "MoveShape";
    /**
     * 手动绘制一个图形
     */
    Mode[Mode["DrawShape"] = 4] = "DrawShape";
})(Mode = exports.Mode || (exports.Mode = {}));
/**
 * 编辑器类
 */
var Editor = /** @class */ (function () {
    function Editor() {
        this.mode = Mode.Move;
        this.mountRoot = null;
        this.drawCanvas = null;
        this.viewport = new viewport_1.ViewPort({
            width: 1024,
            height: 768,
            ctx: utils_1.createCanvasContext2d(),
            transformMatrix: planimetry_1.createTransformMatrix(),
        });
    }
    /**
     * 挂载
     * @param root 挂载的根节点
     */
    Editor.prototype.mount = function (root) {
        var _this = this;
        var dom = null;
        if (typeof root === 'string') {
            var rdom = document.getElementById(root);
            if (rdom) {
                dom = rdom;
            }
            else {
                throw new Error("cont find mounted dom by id:" + root);
            }
        }
        else {
            dom = root;
        }
        dom.style.position = 'relative';
        dom.style.fontSize = '0';
        this.viewport.engine.ctx.canvas.style.position = 'absolute';
        // 覆盖 viewport 的 appendViewPort 方法
        var appendViewPort = this.viewport.appendViewPort;
        this.viewport.appendViewPort = function (v) {
            v.engine.ctx.canvas.style.position = 'absolute';
            dom.appendChild(v.engine.ctx.canvas);
            appendViewPort(v);
        };
        // 覆盖 viewport 的 removeAllViewPort 方法
        var removeAllViewPort = this.viewport.removeAllViewPort;
        this.viewport.removeAllViewPort = function () {
            _this.viewport.viewports.forEach(function (v) { return v.engine.ctx.canvas.remove(); });
            removeAllViewPort();
        };
        dom.appendChild(this.viewport.engine.ctx.canvas);
        this.mountRoot = dom;
        // TODO 需要options来控制其是否需要拖入图片
        this.dropImage();
    };
    /**
     * 绘制一个图形
     * @param drawFn 绘图函数
     * @param autoCancel 是否自动取消
     */
    Editor.prototype.drawShape = function (drawFn, autoCancel) {
        var _this = this;
        if (autoCancel === void 0) { autoCancel = true; }
        if (!this.mountRoot) {
            throw new Error('editor must mounted to a dom');
        }
        var nview = this.viewport.clone();
        var canvas = this.drawCanvas = nview.engine.ctx.canvas;
        canvas.style.position = 'absolute';
        this.mountRoot.appendChild(canvas);
        var clean = function () {
            if (_this.drawCanvas) {
                _this.drawCanvas.remove();
                window.removeEventListener('keydown', escHandler);
                // TODO 模式处理
                return _this.drawShape(drawFn, autoCancel);
            }
        };
        var finish = function (shape) {
            _this.viewport.engine.add(shape);
            _this.viewport.engine.clearAll();
            _this.viewport.engine.render();
            clean();
        };
        drawFn(nview, finish);
        // 绑定取消按键
        var escHandler = function (event) {
            if (event.keyCode == 27) { // 退出键
                clean();
            }
        };
        window.addEventListener('keydown', escHandler);
    };
    /**
     * 通过两次鼠标点击绘制一个图形
     * @param endDraw 第二次点击时候调用
     * @param moveDraw 第一次点击与第二次点击的鼠标移动过程中调用
     */
    Editor.prototype.twoClickDraw = function (endDraw, moveDraw) {
        this.drawShape(function (viewport, finish) {
            var ctx = viewport.engine.ctx;
            var _a = ctx.canvas, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
            var p0 = null;
            var mousedownHandler = function (e) {
                if (p0 === null) {
                    p0 = [e.offsetX - offsetLeft, e.offsetY - offsetTop];
                }
                else {
                    var sPoint = [p0[0], p0[1]]; // 起始点
                    var ePoint = [e.offsetX - offsetLeft, e.offsetY - offsetTop]; // 结束点
                    endDraw({
                        sPoint: sPoint,
                        ePoint: ePoint,
                        viewport: viewport,
                        finish: finish,
                    });
                }
            };
            var mousemoveHandler = function (e) {
                if (p0 !== null) {
                    var sPoint = [p0[0], p0[1]]; // 起始点
                    var ePoint = [e.offsetX - offsetLeft, e.offsetY - offsetTop]; // 结束点
                    moveDraw({
                        sPoint: sPoint,
                        ePoint: ePoint,
                        viewport: viewport,
                        finish: finish,
                    });
                }
            };
            ctx.canvas.addEventListener('mousedown', mousedownHandler);
            ctx.canvas.addEventListener('mousemove', mousemoveHandler);
        });
    };
    /**
     * 通过连续点击绘制一个图形
     */
    Editor.prototype.someClickDraw = function (first, then, move, drawFinish) {
        this.drawShape(function (viewport, finish) {
            var ctx = viewport.engine.ctx;
            var _a = ctx.canvas, offsetTop = _a.offsetTop, offsetLeft = _a.offsetLeft;
            var p0 = null;
            var path = [];
            var mousedownHandler = function (e) {
                if (p0 === null) {
                    p0 = [e.offsetX - offsetLeft, e.offsetY - offsetTop];
                    path.push(p0);
                    // first click
                    first({
                        sPoint: p0,
                        ePoint: p0,
                        finish: finish,
                        viewport: viewport,
                        path: path,
                    });
                }
                else {
                    // const sPoint: Point = [p0[0], p0[1]];    // 起始点
                    var ePoint = [e.offsetX - offsetLeft, e.offsetY - offsetTop]; // 结束点
                    path.push(ePoint);
                    // then click
                    then({
                        sPoint: p0,
                        ePoint: ePoint,
                        finish: finish,
                        viewport: viewport,
                        path: path,
                    });
                }
            };
            var mousemoveHandler = function (e) {
                if (p0 !== null) {
                    // const sPoint: Point = [p0[0], p0[1]];    // 起始点
                    var ePoint = [e.offsetX - offsetLeft, e.offsetY - offsetTop]; // 结束点
                    var order = path.concat([ePoint]);
                    // move
                    move({
                        sPoint: p0,
                        ePoint: ePoint,
                        finish: finish,
                        viewport: viewport,
                        path: order,
                    });
                }
            };
            var finishHandler = function (e) {
                if (e.keyCode === 13) {
                    drawFinish({
                        sPoint: p0,
                        ePoint: p0,
                        finish: finish,
                        viewport: viewport,
                        path: [],
                    });
                    window.removeEventListener('keypress', finishHandler);
                }
            };
            ctx.canvas.addEventListener('mousedown', mousedownHandler);
            ctx.canvas.addEventListener('mousemove', mousemoveHandler);
            window.addEventListener('keypress', finishHandler);
        });
    };
    /**
     * 开始画直线
     */
    Editor.prototype.drawLine = function () {
        this.twoClickDraw(function (tdc) {
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            var line = new shapes_2.ModifyAbleLineShape([s[0], s[1]], [e[0], e[1]]);
            tdc.finish(line);
        }, function (tdc) {
            var ctx = tdc.viewport.engine.ctx;
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.beginPath();
            ctx.moveTo(s[0], s[1]);
            ctx.lineTo(e[0], e[1]);
            ctx.stroke();
        });
    };
    /**
     * 开始画矩形
     */
    Editor.prototype.drawRect = function () {
        this.twoClickDraw(function (tdc) {
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            var shape = new ModifyAbleRectShape_1.ModifyAbleRectShape([s[0], s[1], e[0] - s[0], e[1] - s[1]]);
            tdc.finish(shape);
        }, function (tdc) {
            var ctx = tdc.viewport.engine.ctx;
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.beginPath();
            ctx.strokeRect(s[0], s[1], e[0] - s[0], e[1] - s[1]);
        });
    };
    /**
     * 开始画圆
     */
    Editor.prototype.drawCircle = function () {
        this.twoClickDraw(function (tdc) {
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            var r = planimetry_1.towPointDis(s, e);
            var shape = new shapes_1.CircleShape([[Math.round((s[0] + e[0]) / 2), Math.round((s[1] + e[1]) / 2)], r]);
            tdc.finish(shape);
        }, function (tdc) {
            var ctx = tdc.viewport.engine.ctx;
            var s = tdc.sPoint;
            var e = tdc.ePoint;
            var r = planimetry_1.towPointDis(s, e);
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            R_1.putCircle([[Math.round((s[0] + e[0]) / 2), Math.round((s[1] + e[1]) / 2)], r])(ctx);
        });
    };
    /**
     * 开始画多边形
     */
    Editor.prototype.drawPloygon = function () {
        var ploygon = new shapes_1.PloygonShape([]);
        this.someClickDraw(function (sdctx) {
            sdctx.viewport.engine.add(ploygon);
            // sdctx.viewport.engine.ctx.moveTo(...sdctx.sPoint);
        }, function (sdctx) {
        }, function (sdctx) {
            ploygon.setValue(sdctx.path);
            sdctx.viewport.engine.render(true);
        }, function (sdctx) {
            var d = ploygon.valueOf();
            d.pop();
            ploygon.setValue(d);
            sdctx.finish(ploygon);
        });
    };
    /**
     * 开始选择图形
     */
    Editor.prototype.selectShape = function () {
        var _this = this;
        var h = function (ename) { return function (ev) {
            var offsetLeft = _this.viewport.engine.ctx.canvas.offsetLeft;
            var offsetTop = _this.viewport.engine.ctx.canvas.offsetTop;
            var offsetX = ev.offsetX;
            var offsetY = ev.offsetY;
            _this.viewport.trigger([offsetX - offsetLeft, offsetY - offsetTop], ename);
        }; };
        this.viewport.engine.ctx.canvas.addEventListener('mousedown', h('down'));
        this.viewport.engine.ctx.canvas.addEventListener('mousemove', h('move'));
    };
    /**
     * 移除所有选中的shape
     */
    Editor.prototype.removeAllSelected = function () {
        this.viewport.engine.removeSelected();
        this.viewport.engine.clearAll();
        this.viewport.engine.render();
    };
    Editor.prototype.dropImage = function () {
        var _this = this;
        var preventDefault = function (ev) { return ev.preventDefault(); };
        document.addEventListener('drop', function (ev) {
            ev.preventDefault();
            var transfer = ev.dataTransfer;
            if (transfer) {
                var reader_1 = new FileReader();
                var f = transfer.files.item(0);
                if (f && f.type) {
                    var d = reader_1.readAsDataURL(f);
                    reader_1.onloadend = function () { return __awaiter(_this, void 0, void 0, function () {
                        var ishape;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!reader_1.result) return [3 /*break*/, 2];
                                    return [4 /*yield*/, shapes_1.ImageShape.fetchFromUrl(reader_1.result)];
                                case 1:
                                    ishape = _a.sent();
                                    this.viewport.engine.add(ishape);
                                    this.viewport.engine.render(true);
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); };
                }
            }
        });
        document.addEventListener('drag', preventDefault);
        document.addEventListener('dragend', preventDefault);
        document.addEventListener('dragenter', preventDefault);
        document.addEventListener('dragleave', preventDefault);
        document.addEventListener('dragover', preventDefault);
    };
    /**
     * 清除绘制层
     */
    Editor.prototype.cleanDrawCanvas = function () {
        if (this.drawCanvas) {
            this.drawCanvas.remove();
            this.drawCanvas = null;
        }
        this.viewport.removeAllViewPort();
    };
    return Editor;
}());
exports.Editor = Editor;
//# sourceMappingURL=editor.js.map